import React, { useEffect, useState } from "react";
import * as sweetalert from "sweetalert";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Grid } from "@material-ui/core";
import Controls from "../global/controls/Controls";
import { useForm, Form } from "./useForm";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function CreateZone() {
  const [Countries, setCountries] = useState("");
  const [ErrorLocation, setErrorLocation] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const initialFValues = {
    name: "",
   
  };
  const city= localStorage.getItem("city");

  useEffect(() => {
    axios
      .get(`${BaseUrl}/api/country/1/cities`, {
        withCredentials: true,
      })
      .then((res) => {
        setCountries(res.data.data);
      });
},[]);

  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };

    // if ("DealerCode" in fieldValues)
    //   temp.DealerCode = fieldValues.DealerCode ? "" : "هذا الحقل  مطلوب";
    // if ("DealerPass" in fieldValues)
    //   temp.DealerPass = fieldValues.DealerPass ? "" : "هذا الحقل مطلوب";
    // if ("DealerUserName" in fieldValues)
    //   temp.DealerUserName = fieldValues.DealerUserName ? "" : "هذا الحقل مطلوب";
    // if ("DealerGSM" in fieldValues)
    //   temp.DealerGSM = fieldValues.DealerGSM ? "" : "هذا الحقل مطلوب";
    // if ("GPS" in fieldValues)
    //   temp.GPS = fieldValues.GPS ? "" : "هذا الحقل مطلوب";

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const validate2 = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("gsm" in fieldValues) {
    if (fieldValues.gsm !== "" && !/^[0-9]+$/.test(fieldValues.gsm)) {
        temp.gsm = "يجب أن يكون رقم الموبايل أرقام فقط";
      } else if (fieldValues.gsm !== "" && fieldValues.gsm.length !== 10) {
        temp.gsm = "يجب أن يكون رقم الموبايل 10 أرقام";
      } 
  
      else {
        temp.gsm = "";
      }
    
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const {
    loginInput,
    setLogin,
    errors,
    setErrors,
    handleInputChange,
    addForm,
  } = useForm(initialFValues, true, validate,validate2);

  const handleSubmit = (e) => {
    e.preventDefault();


    if (validate()) {
      setLoading(true);
      const bodyFormData = new FormData();
      bodyFormData.append("name", loginInput.name);


      axios
        .post(
          `${BaseUrl}/api/country/1/city/${city}/zones`,
          bodyFormData,
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          if (res.data.status === true) {
            setLoading(false);
            sweetalert(res.data.message, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {
              navigate(`/city-zone/${city}`);
            });
            
          } else {
            setLoading(false);
            sweetalert(res.data.message, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {
              navigate(`/city-zone/${city}`);
            });
          }
        });
    }
    
  };
  useEffect(() => {
    validate2(loginInput);
  }, [loginInput]);

  useEffect(() => {
    if(loading === true && !validate()) {
    setTimeout(() => {
      // After the timeout, reset the loading state
      setLoading(false);
      // Your other logic here
    }, 2000); // Adjust the timeout duration as needed
    }
  }, [loading]);
  return (
    <div className="main-div">
      <h3 className="titlepage">إضافة منطقة</h3>

      <Form
        className="form-group new-design"
        method="post"
        enctype="multipart/form-data"
        onSubmit={handleSubmit}
      >
        <Grid container maxWidth="sm" spacing={4}>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="المنطقة"
              name="name"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              className="form-control"
              error={errors.name}
              type="text"
            />
          </Grid>
      
    
          
        </Grid>
        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit" style={{justifyContent:'center'}}>
        {loading === true ? (
            <Controls.Button
              type="submit"
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
          <Controls.Button
            type="submit"
            text="إضافة"
            onClick={addForm}
            variant="contained"
            className="btn-submit"
          ></Controls.Button>
          )}
        </Grid>
      </Form>
    </div>
  );
}
